import { Flex, Text, useMantineTheme, ActionIcon, Avatar } from "@mantine/core";
import { useContext, useEffect } from "react";
import { AppContext } from "src/api/AppContext";
import Groups from "./Groups";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTES, CLIENT_TAB_LIST } from "src/utils/constants";
import { FaRegCreditCard } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import useAppMain from "src/hooks/useAppMain";
import { useHeaderContext } from "src/api/context/HeaderContext";
import { BiEdit } from "react-icons/bi";
import { MemberStatus } from "src/generated/graphql";

const Profile = () => {
  const theme = useMantineTheme();
  const { currentUser, currentClient } = useContext(AppContext);
  const navigate = useNavigate();
  const { updateHeaderContent } = useHeaderContext();

  useAppMain(CLIENT_TAB_LIST.PROFILE, false);
  useEffect(() => {
    const editPath = `/${CLIENT_ROUTES.EDIT_PROFILE}`;
    updateHeaderContent(
      <BiEdit
        size={25}
        color={theme.colors.secondaryTextColor[6]}
        onClick={() => {
          navigate(editPath);
        }}
      />
    );
  }, [theme]);

  let color = theme.colors.primaryTextColor[6];
  const locName = currentClient?.defaultLocation?.name;

  return (
    <Flex my={10} direction={"column"} justify={"center"} align={"center"}>
      <Flex
        direction={"column"}
        align={"center"}
        justify={"center"}
        style={{ color: theme.colors.secondaryTextColor[6] }}
      >
        <Avatar
          src={currentUser?.profilePicUrl}
          alt="it's me"
          radius={150}
          size={150}
        />
        <Text
          weight={500}
          size={24}
          mt={20}
        >{`${currentUser?.firstName} ${currentUser?.lastName}`}</Text>
        <Text weight={400} size={16} my={5}>
          {`${
            currentClient?.memberStatus === MemberStatus.Member
              ? "Active"
              : "Inactive"
          } Member`}{" "}
          {locName && `- ${locName}`}
        </Text>
      </Flex>

      <Flex my={20} justify={"flex-start"} direction={"column"} w={"100%"}>
        <Text size={18} fw={500} color={theme.colors.secondaryTextColor[6]}>
          Payments
        </Text>
        <Flex
          p={15}
          my={10}
          align={"center"}
          justify={"space-between"}
          bg={theme.colors.primary[6]}
          style={{ borderRadius: "10px" }}
          onClick={() => navigate(`/${CLIENT_ROUTES.PAYMENT_METHODS}`)}
        >
          <Flex align={"center"}>
            <ActionIcon size="lg" mr={10}>
              <FaRegCreditCard color={theme.colors.primaryTextColor[6]} />
            </ActionIcon>
            <Text fw={500} size={16} color={theme.colors.primaryTextColor[6]}>
              Payment Methods
            </Text>
          </Flex>
          <ActionIcon size="lg">
            <FiChevronRight color={color} />
          </ActionIcon>
        </Flex>
      </Flex>

      <Flex w={"100%"}>
        <Groups />
      </Flex>
    </Flex>
  );
};

export default Profile;
